import {commaizeNumber, formatMetricNumber} from 'common/util';

export function formatDataTableNumber(value: number, {isAverage}: {isAverage: boolean}) {
  return value < 1000000
    ? // For average column, show 1 decimal place even if the value is an integer.
      commaizeNumber(value, {maxPrecision: 1, exactPrecision: isAverage})
    : formatMetricNumber(value);
}
